import { render, staticRenderFns } from "./ITokenCampaignItemsTable.vue?vue&type=template&id=d060fa86&"
import script from "./ITokenCampaignItemsTable.vue?vue&type=script&lang=js&"
export * from "./ITokenCampaignItemsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports